import { render, staticRenderFns } from "./NewsSubscriptionFormPage.vue?vue&type=template&id=4e8803cc&lang=pug&"
import script from "./NewsSubscriptionFormPage.vue?vue&type=script&lang=js&"
export * from "./NewsSubscriptionFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports